export enum EntraUserGroup  {
    GlobalAdmin = 'K12-admin-Global-admin',
    Admin = 'K12.Admin',
}